export const breakpoints = {
  phone: 430,
  tablet: 1000,
};
